import { injectable } from 'inversify';
import { Offset } from '../../interfaces/Offset';
import { RouteEntry } from '../../interfaces/route/RouteEntry';
import { ResultEntry } from '../../interfaces/search/ResultEntry';
import {
  RouteProfile,
  SpeedProfile,
  TimeProfile
} from '../../interfaces/state-events/RoutingRequest';

@injectable()
export class RoutingStorage {
  public speedProfile: SpeedProfile = SpeedProfile.Car;
  public routeProfile: RouteProfile = RouteProfile.Economical;
  public timeProfile: TimeProfile = TimeProfile.Arrival;
  public estimationTime!: string;
  public entry!: ResultEntry;
  public routeEntry!: RouteEntry;
  public offset!: Offset;

  constructor() {
    this.offset = {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    };
  }
}
